// extracted by mini-css-extract-plugin
export default {"root":"Spin_root__cKvZV","icon":"Spin_icon__BTIIr"};